export const customer_routes = {
  index: {
    path: '/customer/*',
    to: '/customer',
  },
  customer_redirect_link: {
    path: 'customer_redirect_link',
    to: '/customer/customer_redirect_link',
    // http://localhost:3000/customer/customer_redirect_link?PaymentRequestId=12342134&Token=adnsdjnd
  },
  // waiting_page: {
  //   path: 'waiting_page',
  //   to: '/customer/waiting_page',
  //   // http://localhost:3000/customer/customer_redirect_link?PaymentRequestId=12342134&Token=adnsdjnd
  // },
  success_page: {
    path: 'success_page',
    to: '/customer/success_page',
  },
  AutoPay: {
    path: 'customer_redirect_link/autopay',
    to: '/customer/customer_redirect_link/autopay',
  },
  customer_payment_summary: {
    path: 'customer_redirect_link/status',
    to: '/customer/customer_redirect_link/status',
  },
  nach_payment_summary: {
    path: 'nach_redirect_link/status',
    to: '/customer/nach_redirect_link/status',
  },
};
